export default "__VITE_ASSET__CMm6i8D9__"